import { render, staticRenderFns } from "./TopArticles.vue?vue&type=template&id=e463406a&"
import script from "./TopArticles.vue?vue&type=script&lang=js&"
export * from "./TopArticles.vue?vue&type=script&lang=js&"
import style1 from "./TopArticles.vue?vue&type=style&index=1&id=e463406a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports